import Vue from 'vue';
import findKey from 'lodash/findKey';

import App from '@/IndexApp.vue';
import hnxSpinner from '@/components/common/HnxSpinner.vue';
import { storage, events, request, loginProvider, api } from '@/hnx/hnx';
import $notifications from '@/notifications';

events.$emit('APP_BeforeInit');

import './app-api';
Vue.config.productionTip = false;
storage.$add('notifications', {list: [], timeout: 10000});
request.$config.baseURL = '/API';
loginProvider.__data.api = api.user;

request.callbacks.onSuccess = (response) => {
	const type = findKey(response.data.result, Boolean);
	const messages = $notifications.toConsumableArray(response.data.message, type);
	$notifications.show(...messages);

	if (response.data.code === 401) {
		window.location.replace(`login.html${window.location.hash}`);
	}

	return response.data;
};

request.callbacks.onError = (response) => {
	const messages = $notifications.toConsumableArray(response.data.message, 'error');
	$notifications.show(...messages);
	return response.data;
};

Vue.component('hnx-spinner', hnxSpinner);

new Vue({
	render: h => h(App)
}).$mount('#app');

events.$emit('APP_AfterInit');
